import { render } from "./Payments.vue?vue&type=template&id=a311fcfc&scoped=true"
import script from "./Payments.vue?vue&type=script&lang=js"
export * from "./Payments.vue?vue&type=script&lang=js"

import "./Payments.vue?vue&type=style&index=0&id=a311fcfc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a311fcfc"]])

export default __exports__